import apiClient from '../../../Services/ApiClient';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { useEffectAsync } from '../../../helpers';

export default function useNCZIConnectionCheck() {
	const [isLogged, setIsLogged] = useState<boolean>(false);
	const { socket } = useAppContext();

	const handleCheckConnection = async () => {
		const {
			data: { available: isConnected },
		} = await apiClient.get('/nczi');
		setIsLogged(isConnected);
	};

	const readCard = async () => {
		const {
			data: { res: readCardResult },
		} = await apiClient.post('/nczi/communicate', {
			eventName: 'readCard',
		});

		return readCardResult;
	};

	const readCardError = async () => {
		const result = await readCard();
		return result.error;
	};

	useEffectAsync(async () => {
		await handleCheckConnection();
	});

	useEffect(() => {
		socket.on('cardConnectConnected', handleCheckConnection);
		return () => {
			socket.off('cardConnectConnected', handleCheckConnection);
		};
	}, []);

	return {
		isCardConnectLogged: isLogged,
		cardConnectReadCard: readCard,
		cardConnectReadCardError: readCardError,
	};
}
